import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { generateAlertusToken, selector as generateTokenSelector, TokenExpiryOption } from "./createAlertusTokenSlice";
import { getCookie } from '../../common/utils';;
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from '@reduxjs/toolkit';
import { listAlertusTokens } from '../../pages/integrations/alertus/listAlertusTokenSlice';
import { useSpinner } from '../../customHooks';
import useNotification from '../notification/useNotification';
export const useCreateAlertusToken = () => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showGeneratedModal, setShowGeneratedModal] = useState(false);
  const [tokenName, setTokenName] = useState("");
  const [tokenExpiry, setTokenExpiry] = useState<TokenExpiryOption | "">("");
  const [generatedToken, setGeneratedToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const apiState=useSelector(generateTokenSelector);
  const {showSuccessNotification, showWarningNotification} = useNotification();
  useSpinner(apiState.status);
  const handleOpenCreateModal = () => {
    setTokenName("");
    setTokenExpiry("");
    setShowCreateModal(true);
  };

  const handleCloseCreateModal = () => setShowCreateModal(false);
  const handleCloseGeneratedModal = () => {
    dispatch(listAlertusTokens());
    setShowGeneratedModal(false)
  };

  const handleCreateToken = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!tokenExpiry) {
      showWarningNotification("Please select a token expiry period");
      return;
    }
    setIsLoading(true);
    const orgId = getCookie('organizationId');
    const email = decodeURIComponent(getCookie('email'));
    const groupId = getCookie('groupId');
    try {
      const payload = {
        tokenName,
        orgId,
        email,
        groupId,
        expiresAt: tokenExpiry,
      };
       setShowCreateModal(false);
      const response = await dispatch(generateAlertusToken(payload)).unwrap();
      setGeneratedToken(response.message.token);
      setShowGeneratedModal(true);
    } catch (error) {
      console.error("Error generating token:", error);
    }
    finally {
      setIsLoading(false);
  }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(generatedToken);
    showSuccessNotification("Token copied to clipboard");
  };


  return {
    showCreateModal,
    showGeneratedModal,
    tokenName,
    setTokenName,
    tokenExpiry,
    setTokenExpiry,
    generatedToken,
    handleOpenCreateModal,
    handleCloseCreateModal,
    handleCloseGeneratedModal,
    handleCreateToken,
    handleCopy,
    isLoading
  };
}